import { render } from "./OnzePublicNewsList.vue?vue&type=template&id=2fff383c"
import script from "./OnzePublicNewsList.vue?vue&type=script&lang=js"
export * from "./OnzePublicNewsList.vue?vue&type=script&lang=js"

import "./OnzePublicNewsList.vue?vue&type=style&index=0&id=2fff383c&lang=css"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
